export default "__VITE_ASSET__BUB5lezf__"